import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const getCompanyAPI = async (company_id) => {
  const data = await phpRequest.get("/company/profile", {
    company_id,
  });
  let companyData = data.company_profile;
  await localforage.setItem(company_id, companyData);
  return companyData;
};
